import script from "./Comment.vue?vue&type=script&lang=ts&setup=true"
export * from "./Comment.vue?vue&type=script&lang=ts&setup=true"

import "./Comment.vue?vue&type=style&index=0&id=2b8955ea&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3182222765/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b8955ea"]])

export default __exports__